const CreateAccount = require("./containers/CreateAccount");

module.exports = {
    path: "/create-account",
    component: CreateAccount,
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/create-account/index.js